import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "help-manual-root" }
const _hoisted_2 = ["id", "aria-labelledby"]
const _hoisted_3 = { class: "offcanvas-header help-manual-header" }
const _hoisted_4 = { class: "help-manual-header-text" }
const _hoisted_5 = ["id"]
const _hoisted_6 = {
  key: 0,
  class: "help-manual-subtitle mb-0"
}
const _hoisted_7 = { class: "help-manual-header-actions" }
const _hoisted_8 = ["data-bs-title", "aria-label"]
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = {
  key: 0,
  class: "help-manual-search-bar"
}
const _hoisted_11 = { class: "input-group input-group-sm" }
const _hoisted_12 = ["placeholder", "aria-label"]
const _hoisted_13 = ["aria-label"]
const _hoisted_14 = { class: "offcanvas-body help-manual-body" }
const _hoisted_15 = {
  key: 0,
  class: "help-manual-status"
}
const _hoisted_16 = {
  key: 1,
  class: "help-manual-status text-danger"
}
const _hoisted_17 = ["aria-label"]
const _hoisted_18 = {
  key: 0,
  class: "help-manual-nav-category"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 1,
  class: "help-manual-nav help-manual-search-results"
}
const _hoisted_21 = { class: "help-manual-nav-category" }
const _hoisted_22 = {
  key: 0,
  class: "help-manual-status"
}
const _hoisted_23 = {
  key: 1,
  class: "help-manual-status text-danger"
}
const _hoisted_24 = {
  key: 2,
  class: "help-manual-status"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "d-block fw-medium" }
const _hoisted_27 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_28 = ["aria-labelledby"]
const _hoisted_29 = {
  key: 0,
  class: "help-manual-content-title"
}
const _hoisted_30 = {
  key: 1,
  class: "help-manual-content-summary text-muted"
}
const _hoisted_31 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "offcanvasElement",
      class: "offcanvas offcanvas-end help-manual-offcanvas",
      tabindex: "-1",
      id: `helpManualOffcanvas-${$props.manual}`,
      "aria-labelledby": `helpManualTitle-${$props.manual}`
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", {
            id: `helpManualTitle-${$props.manual}`,
            class: "offcanvas-title"
          }, [
            _cache[2] || (_cache[2] = _createElementVNode("i", {
              class: "bi bi-question-circle me-2",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */)),
            _createTextVNode(" " + _toDisplayString($setup.label("title", "Help")), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_5),
          ($setup.label('subtitle'))
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($setup.label("subtitle")), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-sm help-manual-pin-btn", $setup.pinned ? 'btn-primary' : 'btn-outline-secondary']),
            "data-bs-toggle": "tooltip",
            "data-bs-title": $setup.pinned ? $setup.label('unpin', 'Unpin') : $setup.label('pin', 'Keep open'),
            "aria-label": $setup.pinned ? $setup.label('unpin', 'Unpin') : $setup.label('pin', 'Keep open'),
            onClick: $setup.togglePinned
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["bi", $setup.pinned ? 'bi-pin-angle-fill' : 'bi-pin-angle']),
              "aria-hidden": "true"
            }, null, 2 /* CLASS */)
          ], 10 /* CLASS, PROPS */, _hoisted_8),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "offcanvas",
            "aria-label": $setup.label('close', 'Close')
          }, null, 8 /* PROPS */, _hoisted_9)
        ])
      ]),
      ($setup.usesDatabase || $props.sections.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "input-group-text" }, [
                _createElementVNode("i", {
                  class: "bi bi-search",
                  "aria-hidden": "true"
                })
              ], -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                ref: "searchInput",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.localSearchQuery) = $event)),
                type: "search",
                class: "form-control",
                placeholder: $setup.label('search_placeholder', 'Search help...'),
                "aria-label": $setup.label('search_placeholder', 'Search help...'),
                onInput: $setup.onSearchInput
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_12), [
                [_vModelText, $setup.localSearchQuery]
              ]),
              ($setup.localSearchQuery)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-outline-secondary",
                    "aria-label": $setup.label('clear_search', 'Clear search'),
                    onClick: _cache[1] || (_cache[1] = $event => {$setup.localSearchQuery = ''; $setup.clearSearch()})
                  }, [...(_cache[3] || (_cache[3] = [
                    _createElementVNode("i", {
                      class: "bi bi-x",
                      "aria-hidden": "true"
                    }, null, -1 /* CACHED */)
                  ]))], 8 /* PROPS */, _hoisted_13))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_14, [
        ($setup.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _cache[5] || (_cache[5] = _createElementVNode("i", {
                class: "bi bi-arrow-repeat spin",
                "aria-hidden": "true"
              }, null, -1 /* CACHED */)),
              _createTextVNode(" " + _toDisplayString($setup.label("loading", "Loading...")), 1 /* TEXT */)
            ]))
          : ($setup.loadError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString($setup.loadError), 1 /* TEXT */))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (!$setup.showingSearchResults)
                  ? (_openBlock(), _createElementBlock("nav", {
                      key: 0,
                      class: "help-manual-nav",
                      "aria-label": $setup.label('table_of_contents', 'Table of contents')
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.displayTocGroups, (group) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: group.category || 'default',
                          class: "help-manual-nav-group"
                        }, [
                          (group.category)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(group.category), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.articles, (section) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: section.id || section.slug,
                              type: "button",
                              class: _normalizeClass(["help-manual-nav-item", { active: (section.id || section.slug) === $setup.currentSectionId }]),
                              onClick: $event => ($setup.selectSection(section.id || section.slug))
                            }, [
                              (section.icon)
                                ? (_openBlock(), _createElementBlock("i", {
                                    key: 0,
                                    class: _normalizeClass([section.icon, "me-2"]),
                                    "aria-hidden": "true"
                                  }, null, 2 /* CLASS */))
                                : _createCommentVNode("v-if", true),
                              _createTextVNode(" " + _toDisplayString(section.title), 1 /* TEXT */)
                            ], 10 /* CLASS, PROPS */, _hoisted_19))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 8 /* PROPS */, _hoisted_17))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, _toDisplayString($setup.label("search_results", "Search results")), 1 /* TEXT */),
                      ($setup.isSearching)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString($setup.label("loading", "Loading...")), 1 /* TEXT */))
                        : ($setup.searchError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString($setup.searchError), 1 /* TEXT */))
                          : (!$setup.searchResults.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString($setup.label("no_results", "No results found")), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchResults, (result) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: result.id || result.slug,
                          type: "button",
                          class: "help-manual-nav-item",
                          onClick: $event => ($setup.selectSearchResult(result))
                        }, [
                          _createElementVNode("span", _hoisted_26, _toDisplayString(result.title), 1 /* TEXT */),
                          (result.summary)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_27, _toDisplayString(result.summary), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ], 8 /* PROPS */, _hoisted_25))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])),
                _createElementVNode("article", {
                  ref: "contentElement",
                  class: "help-manual-content",
                  "aria-labelledby": `helpManualTitle-${$props.manual}`
                }, [
                  ($setup.currentSection)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_29, _toDisplayString($setup.currentSection.title), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  ($setup.currentSection?.summary)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString($setup.currentSection.summary), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  ($setup.currentSection)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "help-manual-content-body",
                        innerHTML: $setup.sectionContent($setup.currentSection)
                      }, null, 8 /* PROPS */, _hoisted_31))
                    : _createCommentVNode("v-if", true)
                ], 8 /* PROPS */, _hoisted_28)
              ], 64 /* STABLE_FRAGMENT */))
      ])
    ], 8 /* PROPS */, _hoisted_2)
  ]))
}